import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { IndustryProvider } from './context/IndustryContext';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './components/AuthCallback';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AgentsSection from './components/AgentsSection';
import CompanyLogos from './components/CompanyLogos';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SecuritySection from './components/SecuritySection';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import ForsytVsGong from './pages/ForsytVsGong';
import ForsytVsClari from './pages/ForsytVsClari';
import ForsytVsScratchpad from './pages/ForsytVsScratchpad';
import BuyVsBuild from './pages/BuyVsBuild';
import OriginStory from './pages/OriginStory';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Dashboard from './pages/Dashboard';
import RiskRadar from './pages/RiskRadar';
import Opportunities from './pages/Opportunities';
import Teams from './pages/Teams';
import Settings from './pages/Settings';
import TodaysFocus from './pages/TodaysFocus';
import AccountDetail from './pages/AccountDetail';
import Solutions from './pages/Solutions';
import Documentation from './pages/Documentation';
import Playbook from './pages/Playbook';
import ROICalculator from './pages/ROICalculator';
import Partners from './pages/Partners';
import ProductPage from './pages/ProductPage';
import SecurityPage from './pages/SecurityPage';
import SubProcessors from './pages/SubProcessors';
import PluginsPage from './pages/PluginsPage';
import PluginDetailPage from './pages/PluginDetailPage';
import BriefingsPage from './pages/BriefingsPage';
import HowForsytRollsIn from './components/HowForsytRollsIn';
import CROCommunityPage from './pages/CROCommunityPage';
import CommunityApplyPage from './pages/CommunityApplyPage';
import CommunityInboxPage from './pages/CommunityInboxPage';
import CommunityInvitePage from './pages/CommunityInvitePage';
import AdminCommunityPage from './pages/AdminCommunityPage';

import SEO from './components/SEO';

const Home = () => {
  return (
    <div>
      <SEO
        title="Revenue OS, Tells Your Team Exactly What To Do Next"
        description="Forsyt is the Revenue OS that sits on top of your CRM, calls, email, and Slack to identify the 1 deal that truly matters, pinpoint the real blocker, and prescribe the exact next action, automatically. Backed by T9L."
        path="/"
      />
      <Header />
      <main>
        <HeroSection />
        <CompanyLogos />
        <HowForsytRollsIn />
        <FeaturesSection />
        <AgentsSection />
        <FAQSection />
        <SecuritySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function AppInner() {
  const location = useLocation();
  // Handle the OAuth return (session_id in URL fragment) before any routing.
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/origin-story" element={<OriginStory />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/vs-gong" element={<ForsytVsGong />} />
          <Route path="/vs-clari" element={<ForsytVsClari />} />
          <Route path="/vs-scratchpad" element={<ForsytVsScratchpad />} />
          <Route path="/buy-vs-build" element={<BuyVsBuild />} />
          <Route path="/solutions/:role" element={<Solutions />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/sub-processors" element={<SubProcessors />} />
          {/* /trust is consolidated into /security#trust-center */}
          <Route path="/trust" element={<Navigate to="/security#trust-center" replace />} />
          <Route path="/resources/documentation" element={<Documentation />} />
          <Route path="/resources/playbook" element={<Playbook />} />
          <Route path="/resources/roi-calculator" element={<ROICalculator />} />
          <Route path="/resources/partners" element={<Partners />} />
          <Route path="/plugins" element={<PluginsPage />} />
          <Route path="/plugins/:slug" element={<PluginDetailPage />} />
          <Route path="/briefings" element={<BriefingsPage />} />
          <Route path="/community" element={<CROCommunityPage />} />
          <Route path="/community/apply" element={<CommunityApplyPage />} />
          <Route path="/community/invite/:token" element={<CommunityInvitePage />} />
          <Route path="/community/inbox" element={<CommunityInboxPage />} />
          <Route path="/admin/community" element={<AdminCommunityPage />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<Navigate to="todays-focus" replace />} />
            <Route path="risk-radar" element={<RiskRadar />} />
            <Route path="opportunities" element={<Opportunities />} />
            <Route path="opportunities/:id" element={<AccountDetail />} />
            <Route path="teams" element={<Teams />} />
            <Route path="settings" element={<Settings />} />
            <Route path="todays-focus" element={<TodaysFocus />} />
          </Route>
        </Routes>
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <IndustryProvider>
            <AppInner />
          </IndustryProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
